import { orange500, white } from 'material-ui/styles/colors';

export const styles = (theme) => ({
  flexRow: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  loadingWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 0px',
  },
  paperRoot: {
    width: '95%',
    margin: '0 auto',
    marginTop: theme.spacing.unit * 3,
  },
  spacer: {
    flex: '1 1 100%',
  },
  temperatureContainer: {
    marginRight: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  temperatureItem: {
    width: '15px',
    height: '15px',
    borderRadius: '50%',
  },
  potential: {
    background: theme.palette.primary.main,
  },
  cold: {
    background: white,
    border: '1px solid lightgray',
  },
  hot: {
    background: orange500,
  },
});

export default styles;
